export default __webpack_public_path__ + "static/media/255.99a582d3.png";